// extracted by mini-css-extract-plugin
module.exports = {"noprint":"Header_noprint__swjX2","onprint":"Header_onprint__2sjUq"};